// extracted by mini-css-extract-plugin
export default {"creator":"Footer_creator__Seq0H","creator__item":"Footer_creator__item__vsP6l","link":"Footer_link__Lkz1i","socs":"Footer_socs__+orVx","wrap":"Footer_wrap__RCO59"};